import { G } from '@mobily/ts-belt';

const BoOriginsProd = [
  'bo.shares.io',
  'bo-external.shares.io',
  'bo-ext.shares.io',
  'bo-ext2.shares.io',
  'bo.partner2.shares.io',
  'bo-external.partner2.shares.io',
  'bo-ext.partner2.shares.io',
  'bo-ext2.partner2.shares.io',
  'espace-pro.axa-mon-epargne-entreprises.com',
  'espace-apporteur.axa-mon-epargne-entreprises.com',
  'bo-es.axa-mon-epargne-entreprises.com',
];
const BoOriginsDev = [
  'bo.dev-shares.io',
  'bo-external.dev-shares.io',
  'bo-ext.dev-shares.io',
  'bo-ext2.dev-shares.io',
  'bo.dev-partner2.shares.io',
  'bo-external.dev-partner2.shares.io',
  'bo-ext.dev-partner2.shares.io',
  'bo-ext2.dev-partner2.shares.io',
  'rec.espace-pro.axa-mon-epargne-entreprises.com',
  'rec.espace-apporteur.axa-mon-epargne-entreprises.com',
  'rec-bo-es.axa-mon-epargne-entreprises.com',
  'bo.dev-mlk.shares.io',
  'bo-external.dev-mlk.shares.io',
];
const BoOriginsStg = [
  'bo.staging-shares.io',
  'bo-external.staging-shares.io',
  'bo-ext.staging-shares.io',
  'bo-ext2.staging-shares.io',
  'bo.staging-partner2.shares.io',
  'bo-external.staging-partner2.shares.io',
  'bo-ext.staging-partner2.shares.io',
  'bo-ext2.staging-partner2.shares.io',
  'pp.espace-pro.axa-mon-epargne-entreprises.com',
  'pp.espace-apporteur.axa-mon-epargne-entreprises.com',
  'pp-bo-es.axa-mon-epargne-entreprises.com',
  'bo.staging-mlk.shares.io',
  'bo-external.staging-mlk.shares.io',
  'bo-ext.staging-mlk.shares.io',
  'bo.mig-mlk.shares.io',
  'bo-external.mig-mlk.shares.io',
  'bo-ext.mig-mlk.shares.io',
];
const BoOriginsLocal = ['gitpod.io', 'localhost', 'coder.shares.io', 'cde.shares.io'];
const BoOriginsAxa = ['partner2.shares.io', 'axa-mon-epargne-entreprises.com'];
const BoOriginsMlk = ['mlk.shares.io'];
const BoOrigins = [...BoOriginsProd, ...BoOriginsDev, ...BoOriginsStg, ...BoOriginsLocal];

export const isNotProdEnv = (): boolean => isBoLink(window.location.host) && !isProdEnv();

export const isProdEnv = (): boolean => BoOriginsProd.includes(window.location.host);

export const isDevEnv = (): boolean => BoOriginsDev.includes(window.location.host);

export const isLocalEnv = (): boolean =>
  BoOriginsLocal.some((origin) => window.location.origin.includes(origin));

export const isStgEnv = (): boolean => BoOriginsStg.includes(window.location.host);

export const isProdLikeEnv = (): boolean => isProdEnv() || isDevEnv() || isStgEnv();

export const isAxaEnv = (): boolean =>
  BoOriginsAxa.some((origin) => window.location.host.includes(origin));

export const isMlkEnv = (): boolean =>
  BoOriginsMlk.some((origin) => window.location.host.includes(origin));

export const isB2BEnv = (): boolean => isAxaEnv() || isMlkEnv();

export const isBoLink = (origin: string) => BoOrigins.some((boOrigin) => origin.includes(boOrigin));

export const isBoExternal = (): boolean =>
  // eslint-disable-next-line n/no-process-env -- replaced by webpack
  JSON.parse(process.env.IS_BO_EXTERNAL || 'false') as boolean;

export function getEnvVar(key: keyof typeof process.env): string | undefined {
  // eslint-disable-next-line n/no-process-env -- allowed only here
  return process.env[key];
}

function getCurrentEnvName() {
  if (isDevEnv()) {
    return 'dev';
  }
  if (isStgEnv()) {
    return 'staging';
  }
  if (isProdEnv()) {
    return 'prod';
  }
  return 'local';
}
function getCurrentPartnerEnvName() {
  if (isAxaEnv()) {
    return 'axa';
  }
  if (isMlkEnv()) {
    return 'mlk';
  }
}

export function getCurrentEnvWholeName() {
  const currentEnvName = getCurrentEnvName();
  const currentPartnerEnvName = getCurrentPartnerEnvName();
  if (G.isNullable(currentPartnerEnvName)) {
    return currentEnvName;
  }
  return `${currentEnvName}-${currentPartnerEnvName}`;
}
